<template>
  <div class="product">
    <el-divider content-position="center" class="mb"
      ><h1>社会创新</h1></el-divider
    >
    <span>
      推动社会进步，共创文明城市。在文明城市的创建进程中，公益事业和思想品德教育是重中之重，我们是社会的一份子，理应为社会的精神文明进步出一份力。</span
    >
    <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/PW1.jpg')"></el-image>
        <div class="desc">(VR垃圾分类应用，被重庆电视台报道)</div>
      </el-col>
    </el-row>
     <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/PW2.jpg')"></el-image>
        <div class="desc">(新时代文化实践产品 便携VR党建)</div>
      </el-col>
    </el-row>
     <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/PW3.jpg')"></el-image>
        <div class="desc">(守护星学生安全教育解决方案)</div>
      </el-col>
    </el-row>
   
    <el-row>
      <el-col>
        <router-link tag="div" class="btn" :to="{ name: 'company1' }">
          返回上层
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang='less'>
.mb {
  margin: 40px 0;
}
.el-row {
  margin: 20px 0;
}
.product {
  margin-top: 20px;
  // border: 1px solid #000;
}
h1 {
  font-size: 28px;
}
span {
  color: #999;
  font-size: 24px;
  line-height: 36px;
}
.desc {
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}
.el-col {
  text-align: center;
}
.btn {
  cursor: pointer;
  margin: 10px auto;
  padding: 10px;
  width: 200px;
  border-radius: 10px;
  color: #fff;
  background-image: linear-gradient(to top, #f0ad4e 0%, #eb9316 100%);
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.075);
  &:hover {
    background-image: linear-gradient(20deg, #f0ad4e 0%, #eb9316 100%);
    box-shadow: inset 1px 1px 0 rgba(255, 255, 255, 0.15),
      0 1px 1px rgba(0, 0, 0, 0.075);
  }
}
@media screen and (max-width: 768px) {
  h1 {
    font-size: 18px;
  }
  span {
    font-size: 14px;
  }
}
</style>